import React, { useState, useEffect, useCallback } from 'react'
import Image from "next/image";
import { BASE_ASSETS_URL } from '../../../constants/constants';


const RoofingCalc = () => {
   // const UNIT_CONVERSIONS = {
   //    sqft: 1,
   //    sqm: 10.7639,
   //    sqyd: 9,
   //    sqin: 144,
   //    sqcm: 929.03,
   //    ft: 1,
   //    m: 3.28084,
   //    yd: 0.333333,
   //    in: 12,
   //    cm: 30.48,
   // };


   const [houseDimensions, setHouseDimensions] = useState({
      houseLength: "",
      houseWidth: "",
      houseArea: "",
      houseBaseUnit: "sqm"
   })

   const [roofPitch, setRoofPitch] = useState({
      pitchDegree: "",
      degreeCalculated: false,
      pitchPercent: "",
      percentCalculated: false,
      pitchRatio: "",
      ratioCalculated: false,
   })

   const [roofCost, setRoofCost] = useState({
      roofArea: "",
      roofAreaUnit: "sqm",
      unitPrice: "",
      unitPriceBase: "sqm",
      roofTotalCost: "",

   })


   function handleAreaChange(event) {
      setHouseDimensions({ ...houseDimensions, houseLength: '', houseWidth: '', houseArea: event.target.value })
   }

   useEffect(() => {
      if (houseDimensions.houseWidth !== "" && houseDimensions.houseLength !== "") {
         setHouseDimensions({ ...houseDimensions, houseArea: houseDimensions.houseLength * houseDimensions.houseWidth })

      }
   }, [houseDimensions.houseLength, houseDimensions.houseWidth])





   useEffect(() => {
      if (roofPitch.pitchDegree !== '' && !roofPitch.degreeCalculated) {
         const pitchInRadians = roofPitch.pitchDegree * (Math.PI / 180);
         const pitchInPercentage = Math.tan(pitchInRadians) * 100;
         const pitchInRatio = `${(12 / (100 / (100 * Math.tan(roofPitch.pitchDegree * (Math.PI / 180))))).toFixed(3)}`;
         setRoofPitch({ ...roofPitch, pitchPercent: pitchInPercentage.toFixed(2), percentCalculated: true, pitchRatio: pitchInRatio, ratioCalculated: true })

      }
   }, [roofPitch.pitchDegree]);

   //  useEffect(() => {
   //    if (roofPitch.pitchPercent !== '' && !roofPitch.percentCalculated) {
   //      const pitchInRadians = Math.atan(roofPitch.pitchPercent / 100);
   //      const pitchInDegree = pitchInRadians * (180 / Math.PI);
   //    //   const pitchInRatio = `1:${1 / Math.tan(pitchInRadians)}`;
   //      const pitchInRatio = `${(12/(100/(100* Math.tan(roofPitch.pitchDegree * (Math.PI/180))))).toFixed(3)}`;
   //      setRoofPitch({...roofPitch, pitchDegree:pitchInDegree.toFixed(2),degreeCalculated:true, pitchRatio:pitchInRatio, ratioCalculated:true})
   //    }
   //  }, [roofPitch.pitchPercent]);

   useEffect(() => {
      if (roofPitch.pitchRatio !== '' && !roofPitch.ratioCalculated) {
         const pitchInRadians = Math.atan(roofPitch.pitchRatio / 12);
         const pitchInDegree = pitchInRadians * (180 / Math.PI);
         const pitchInPercentage = Math.tan(pitchInRadians) * 100;
         setRoofPitch({ ...roofPitch, pitchDegree: pitchInDegree.toFixed(2), degreeCalculated: true, pitchPercent: pitchInPercentage.toFixed(2), percentCalculated: true })
      }
   }, [roofPitch.pitchRatio]);


   function calculateRoofArea() {
      const pitchInRadians = roofPitch.pitchDegree * (Math.PI / 180);
      const totalRoofArea = houseDimensions.houseArea / Math.cos(pitchInRadians);

      // Convert to desired unit of measurement
      
      let roofAreaConverted;

      if(houseDimensions.houseBaseUnit === 'sqm'){
         switch (roofCost.roofAreaUnit) {
            case 'sqm':
               roofAreaConverted = totalRoofArea;
               break;
            case 'sqft':
               roofAreaConverted = totalRoofArea * 10.7639;
               break;
            case 'sqyd':
               roofAreaConverted = totalRoofArea * 1.19599;
               break;
            case 'sqin':
               roofAreaConverted = totalRoofArea * 1550.0031;
               break;
            case 'sqcm':
               roofAreaConverted = totalRoofArea * 10000;
               break;
            default:
               roofAreaConverted = totalRoofArea;
         }
      }else if(houseDimensions.houseBaseUnit === 'sqft'){
         switch (roofCost.roofAreaUnit) {
            case 'sqm':
               roofAreaConverted = totalRoofArea / 10.7639;
               break;
            case 'sqft':
               roofAreaConverted = totalRoofArea;
               break;
            case 'sqyd':
               roofAreaConverted = totalRoofArea / 9;
               break;
            case 'sqin':
               roofAreaConverted = totalRoofArea * 144;
               break;
            case 'sqcm':
               roofAreaConverted = totalRoofArea * 929.03;
               break;
            default:
               roofAreaConverted = totalRoofArea;
         }
      }else if(houseDimensions.houseBaseUnit === 'sqyd'){
         switch (roofCost.roofAreaUnit) {
            case 'sqm':
               roofAreaConverted = totalRoofArea / 1.19599;
               break;
            case 'sqft':
               roofAreaConverted = totalRoofArea * 9;
               break;
            case 'sqyd':
               roofAreaConverted = totalRoofArea;
               break;
            case 'sqin':
               roofAreaConverted = totalRoofArea * 1296;
               break;
            case 'sqcm':
               roofAreaConverted = totalRoofArea * 8361.2736;
               break;
            default:
               roofAreaConverted = totalRoofArea;
         }
      }else if(houseDimensions.houseBaseUnit === 'sqin'){
         switch (roofCost.roofAreaUnit) {
            case 'sqm':
               roofAreaConverted = totalRoofArea / 1550.0031;
               break;
            case 'sqft':
               roofAreaConverted = totalRoofArea / 144;
               break;
            case 'sqyd':
               roofAreaConverted = totalRoofArea / 1296;
               break;
            case 'sqin':
               roofAreaConverted = totalRoofArea;
               break;
            case 'sqcm':
               roofAreaConverted = totalRoofArea * 6.4516;
               break;
            default:
               roofAreaConverted = totalRoofArea;
         }
      }else if(houseDimensions.houseBaseUnit === 'sqcm'){
         switch (roofCost.roofAreaUnit) {
            case 'sqm':
               roofAreaConverted = totalRoofArea / 10000;
               break;
            case 'sqft':
               roofAreaConverted = totalRoofArea / 929.03;
               break;
            case 'sqyd':
               roofAreaConverted = totalRoofArea / 8361.2736;
               break;
            case 'sqin':
               roofAreaConverted = totalRoofArea / 6.4516;
               break;
            case 'sqcm':
               roofAreaConverted = totalRoofArea;
               break;
            default:
               roofAreaConverted = totalRoofArea;
         }
      }
   
      return roofAreaConverted;
   }

   useEffect(() => {
      if (houseDimensions.houseArea !== '' && roofPitch.pitchDegree !== '') {
         const totalRoofArea = calculateRoofArea();
         setRoofCost({ ...roofCost, roofArea: totalRoofArea.toFixed(2) })
      }
   },[houseDimensions.houseArea, roofPitch.pitchDegree, roofCost.roofAreaUnit])

   
   // useEffect(()=>{
   //    if(roofCost.roofArea !== ''){
   //       const totalCost = roofCost.roofArea * roofCost.unitPrice;
   //       setRoofCost({...roofCost, roofTotalCost:totalCost.toFixed(2)})
   //    }
   // },[roofCost.unitPrice, roofCost.unitPriceBase])

   return (
      <div className="w-full max-w-[1000px] bg-gray-200 mx-auto py-[30px] px-[5px] md:px-[30px] rounded-sm drop-shadow-lg flex flex-col lg:flex-row gap-[20px]">
         <div className="max-w-[100%] lg:w-[50%] h-full">
            <div className="flex flex-col gap-[20px]">
               <div className="text-gray-500 flex flex-col gap-[2px]">
                  <h3 className="text-gray-200 bg-violet-500 font-medium text-[18px] border-b-2 py-[10px] text-center mb-[10px]">House Dimensions</h3>
                  <div className="flex justify-between items-center rounded-sm">
                     <h3 className="text-gray-600 font-medium text-[16px] w-[40%]">House Length</h3>
                     <div className="flex items-center justify-between w-[60%] border border-gray-500">
                        <input
                           className="border-none bg-transparent text-gray-600 outline-none py-2 px-3 w-full h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={houseDimensions.houseLength}
                           onChange={(e) => { setHouseDimensions({ ...houseDimensions, houseLength: e.target.value }) }}
                        />
                        <select
                           className="border-none bg-transparent text-gray-600 outline-none h-[50px] w-[55px]"
                           id=""
                           name=""
                           required
                           value={houseDimensions.houseBaseUnit}
                           onChange={(e) => { setHouseDimensions({ ...houseDimensions, houseBaseUnit: e.target.value }) }}
                        >
                           <option value="sqm" className="bg-white">m &nbsp; &nbsp;&nbsp;metres</option>
                           <option value="sqft" className="bg-white">ft &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;feet</option>
                           <option value="sqyd" className="bg-white">yd &nbsp; &nbsp;&nbsp;yards</option>
                           <option value="sqin" className="bg-white">in &nbsp; &nbsp;&nbsp;&nbsp;inches</option>
                           <option value="sqcm" className="bg-white">cm &nbsp; cm</option>
                        </select>
                     </div>
                  </div>
                  <div className="flex justify-between items-center rounded-sm">
                     <h3 className="text-gray-600 font-medium text-[16px] w-[40%]">House Width</h3>
                     <div className="flex items-center justify-between w-[60%] border border-gray-500">
                        <input
                           className="bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={houseDimensions.houseWidth}
                           onChange={(e) => { setHouseDimensions({ ...houseDimensions, houseWidth: e.target.value }) }}
                        />
                        <select
                           className="border-none bg-transparent text-gray-600 outline-none rounded-md h-[50px] w-[55px]"
                           id=""
                           name=""
                           required
                           value={houseDimensions.houseBaseUnit}
                           onChange={(e) => { setHouseDimensions({ ...houseDimensions, houseBaseUnit: e.target.value }) }}
                        >
                           <option value="sqm" className="bg-white">m &nbsp; &nbsp;&nbsp;metres</option>
                           <option value="sqft" className="bg-white">ft &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;feet</option>
                           <option value="sqyd" className="bg-white">yd &nbsp; &nbsp;&nbsp;yards</option>
                           <option value="sqin" className="bg-white">in &nbsp; &nbsp;&nbsp;&nbsp;inches</option>
                           <option value="sqcm" className="bg-white">cm &nbsp; cm</option>
                        </select>
                     </div>
                  </div>
                  {/* <div className="flex justify-center items-center gap-[10px]">
                     <div className="h-[1px] bg-gray-200 flex-1"></div>
                     <div className="text-center text-gray-600 text-[20px]">OR</div>
                     <div className="h-[1px] bg-gray-200 flex-1"></div>
                  </div> */}
                  <div className="flex justify-between items-center rounded-sm">
                     <h3 className="text-gray-600 font-medium text-[16px] w-[40%]">House Base Area</h3>
                     <div className="flex items-center justify-between w-[60%] border border-gray-500">
                        <input
                           className="bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={houseDimensions.houseArea}
                           onChange={handleAreaChange}
                        />
                        <select
                           className="border-none bg-transparent text-gray-600 outline-none rounded-md h-[50px] w-[55px]"
                           id=""
                           name=""
                           required
                           value={houseDimensions.houseBaseUnit}
                           onChange={(e) => { setHouseDimensions({ ...houseDimensions, houseBaseUnit: e.target.value }); setRoofCost({ ...roofCost, roofAreaUnit: e.target.value }) }}
                        >
                           <option value="sqm" className="bg-white">m² &nbsp;&nbsp;square metres</option>
                           <option value="sqft" className="bg-white">ft² &nbsp;&nbsp;&nbsp;&nbsp;square feet</option>
                           <option value="sqyd" className="bg-white">yd² &nbsp;&nbsp;square yards</option>
                           <option value="sqin" className="bg-white">in² &nbsp;&nbsp;&nbsp;square inches</option>
                           <option value="sqcm" className="bg-white">cm² square cm</option>
                        </select>
                     </div>
                  </div>
               </div>
               <div className="text-gray-500 flex flex-col gap-[2px]">
                  <h3 className="text-gray-200 bg-violet-500 font-medium text-[18px] border-b-2 py-[10px] text-center mb-[10px]">Roof Pitch</h3>
                  <div className="flex justify-between items-center rounded-sm">
                     <h3 className="text-gray-600 font-medium text-[16px] w-[40%]">Roof Pitch</h3>
                     <div className="flex items-center justify-between w-[60%] border border-gray-500">
                        <input
                           className="border-none bg-transparent text-gray-600 outline-none py-2 px-3 w-full h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={roofPitch.pitchDegree}
                           onChange={(e) => { setRoofPitch({ ...roofPitch, pitchDegree: e.target.value, degreeCalculated: false }) }}
                        // onChange={handlePitchDegreeChange}
                        />
                        <div
                           className="border-none bg-transparent text-gray-600 outline-none h-[50px] w-[55px] grid place-items-center"
                           id=""
                           name=""
                           required
                        >
                           deg
                        </div>
                     </div>
                  </div>
                  {/* <div className="flex justify-between items-center rounded-sm">
                     <h3 className="text-gray-600 font-medium text-[16px] w-[40%]">Roof Pitch (%)</h3>
                     <div className="flex items-center justify-between w-[60%] border">
                        <input
                           className="bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={roofPitch.pitchPercent}
                           onChange={(e)=>{setRoofPitch({...roofPitch, pitchPercent:e.target.value, percentCalculated:false})}}
                        />
                        <div
                           className="border-none bg-transparent text-gray-600 outline-none h-[50px] w-[55px] grid place-items-center"
                           id=""
                           name=""
                           required
                        >
                           %
                        </div>
                     </div>
                  </div> */}
                  <div className="flex justify-between items-center rounded-sm">
                     <h3 className="text-gray-600 font-medium text-[16px] w-[40%]">Roof Pitch(x:12)</h3>
                     <div className="flex items-center justify-between w-[60%] border border-gray-500">
                        <input
                           className="bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={roofPitch.pitchRatio}
                           onChange={(e) => { setRoofPitch({ ...roofPitch, pitchRatio: e.target.value, ratioCalculated: false }) }}
                        />
                        <div
                           className="border-none bg-transparent text-gray-600 outline-none h-[50px] w-[55px] grid place-items-center"
                           id=""
                           name=""
                           required
                        >
                           :12
                        </div>
                     </div>
                  </div>
               </div>
               <div className="text-gray-500 flex flex-col gap-[2px]">
                  <h3 className="text-gray-200 bg-violet-500 font-medium text-[18px] border-b-2 py-[10px] text-center mb-[10px]">Roof Cost</h3>
                  <div className="flex justify-between items-center rounded-sm">
                     <h3 className="text-gray-600 font-medium text-[16px] w-[40%]">Roof area</h3>
                     <div className="flex items-center justify-between w-[60%] border border-gray-500">
                        <input
                           className="border-none bg-transparent text-gray-600 outline-none py-2 px-3 w-full h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={roofCost.roofArea}
                           onChange={(e) => { setRoofCost({ ...roofCost, roofArea: e.target.value }) }}
                        />
                        <select
                           className="border-none bg-transparent text-gray-600 outline-none rounded-md h-[50px] w-[55px]"
                           id=""
                           name=""
                           required
                           value={roofCost.roofAreaUnit}
                           onChange={(e) => { setRoofCost({ ...roofCost, roofAreaUnit: e.target.value }) }}
                        >
                           <option value="sqm" className="bg-white">m² &nbsp;&nbsp;square metres</option>
                           <option value="sqft" className="bg-white">ft² &nbsp;&nbsp;&nbsp;&nbsp;square feet</option>
                           <option value="sqyd" className="bg-white">yd² &nbsp;&nbsp;square yards</option>
                           <option value="sqin" className="bg-white">in² &nbsp;&nbsp;&nbsp;square inches</option>
                           <option value="sqcm" className="bg-white">cm² square cm</option>
                        </select>
                     </div>
                  </div>
                  <div className="flex justify-between items-center rounded-sm">
                     <h3 className="text-gray-600 font-medium text-[16px] w-[40%]">Unit Price</h3>
                     <div className="flex items-center justify-between w-[60%] border border-gray-500">
                        <input
                           className="bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={roofCost.unitPrice}
                           onChange={(e) => { setRoofCost({ ...roofCost, unitPrice: e.target.value }) }}
                        />
                        $/<select
                           className="border-none bg-transparent text-gray-600 outline-none rounded-md h-[50px] w-[55px]"
                           id=""
                           name=""
                           required
                           value={roofCost.roofAreaUnit}
                           onChange={(e) => { setRoofCost({ ...roofCost, roofAreaUnit: e.target.value })}}
                        >
                           <option value="sqm" className="bg-white">m² &nbsp;&nbsp;square metres</option>
                           <option value="sqft" className="bg-white">ft² &nbsp;&nbsp;&nbsp;&nbsp;square feet</option>
                           <option value="sqyd" className="bg-white">yd² &nbsp;&nbsp;square yards</option>
                           <option value="sqin" className="bg-white">in² &nbsp;&nbsp;&nbsp;square inches</option>
                           <option value="sqcm" className="bg-white">cm² square cm</option>
                        </select>
                     </div>
                  </div>
                  <div className="flex justify-between items-center rounded-sm">
                     <h3 className="text-gray-600 font-medium text-[16px] w-[40%]">Total cost</h3>
                     <div className="flex items-center justify-between w-[60%] border border-gray-500">
                        <input
                           className="bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           readOnly
                           value={(roofCost.roofArea * roofCost.unitPrice).toFixed(2)}
                           // onChange={(e) => { setRoofCost({ ...roofCost, roofTotalCost: e.target.value }) }}
                        />
                        <div
                           className="border-none bg-transparent text-gray-600 outline-none h-[50px] w-[55px] grid place-items-center"
                           id=""
                           name=""
                           required
                        >
                           $
                        </div>
                     </div>
                  </div>
               </div>
               {/* <button onClick={() => handleCalculate()} className="w-full h-[50px] mt-[20px] bg-violet-500 hover:opacity-75 text-white font-medium text-[18px] rounded-lg shadow-2xl">Calculate</button> */}

            </div>
         </div>
         <div className="w-[100%] lg:w-[50%] grid place-items-center py-[30px] gap-[20px]">
            {/* <h3 className="text-white py-[2px] mb-[10px] h-[50px] flex items-center text-center justify-center px-[10px] font-medium text-[25px] bg-violet-500">Roofing Area Calculator</h3> */}
            <h1 className="text-center text-gray-500 text-[50px] uppercase font-light">Roofing <br /> Calculator</h1>
            <Image width="20" height="20" className="w-full mx-auto"
               loading="lazy"
               src={`${BASE_ASSETS_URL}/house.png`}
               alt="" />
            <h1 className="text-center text-gray-500 text-[25px] font-light">Calculate Roof Area by providing House area and Roof Pitch.</h1>
         </div>
      </div>
   )
}

export default RoofingCalc
